import { Card, CardContent } from '@repo/ui/card'
import { cn } from '@repo/ui/utils'
import { Loader2 } from 'lucide-react'

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <Card className={cn('h-full min-h-96 w-full min-w-[330px]', className)}>
      <div className="flex w-full flex-shrink-0 flex-col gap-2 p-6">
        <div className="bg-primary-200 w-60 animate-pulse rounded-md p-3" />
        <div className="bg-primary-100 w-40 animate-pulse rounded-md p-2" />
      </div>
      <CardContent className="flex h-full min-h-60 flex-1 items-center justify-center">
        <Loader2 className="text-primary-100 h-20 w-20 animate-spin opacity-30" />
      </CardContent>
    </Card>
  )
}
